export default {
  methods: {
    multiSelectDecodeBuilder(options) {
      // eslint-disable-next-line func-names
      return (idStr, { _default }) => {
        // We take our id string and split, clean and parse it into a nice array
        const ids = idStr
          .split(',')
          .filter((v) => v !== '')
          .map((id) => Number.parseInt(id, 10))

        // Depending on our size we quickly finish now
        if (ids.length === options.length) return options
        if (ids.length === 0) return _default

        // lookup table
        const lookup = options.reduce((obj, cat) => {
          // eslint-disable-next-line no-param-reassign
          obj[cat.id] = cat
          return obj
        }, {})

        // We can now quickly find our option from our id
        return ids.filter((id) => lookup.hasOwnProperty(id)).map((id) => lookup[id])
      }
    },
  },
}
